import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';

/**
 * @usePostData
 * @post_type testimonial
 */
export interface IVHSQuoteProps extends IBaseElementProps {
	/**
	 * Text
	 */
	text?: string;
	/**
	 * Author
	 */
	author?: string;
	/**
	 * Role
	 */
	role?: string;
}

const VHSQuote: React.FC<IVHSQuoteProps> = ({
	text,
	author,
	role,
	className,
	classNames = [],
}) => (
	<div className={className || cn('vhs-quote', ...classNames)}>
		{text && (
			<div className="vhs-quote__container">
				<p className="vhs-quote__text">{text}</p>
				{author && <div className="vhs-quote__author">{author}</div>}
				{role && <div className="vhs-quote__role">{role}</div>}
			</div>
		)}
	</div>
);

export default VHSQuote;
